import React from 'react'
import styled from 'styled-components'

export default () => {
  return (
    <ColumnText>Rhapsodist</ColumnText>
  )
}

const ColumnText = styled.p`
  color: ${params => params.theme.darkBeige};
  font-size: 9.5rem;
  letter-spacing: 0.3rem;
  display: inline-block;
  transform: rotate(-90deg);
  font-family: ELEPHNT;
  position: fixed;
  font-weight: 100;
  padding: 0;
  bottom: 0;
  margin: 0;
  width: 9rem;
  z-index: -10;
  display: none;
  @media(min-width: 900px) {
    display: block;
  }
`